import "./tablestyle.scss";
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridItemChangeEvent,
  GridPageChangeEvent,
  GridPagerSettings,
  GridRowProps,
  GridNoRecords
} from "@progress/kendo-react-grid";
import { Link, useNavigate } from "react-router-dom";
import { SortDescriptor } from "@progress/kendo-data-query";
import { useState } from "react";
import { Icon } from "@iconify/react";


function CompanyTimesheet(Props: any) {

  const navigate = useNavigate()
  const initialSort: Array<SortDescriptor> = [
    { field: "", dir: "asc" },
  ];

  const [sort, setSort] = useState(initialSort);
  const openInNewTab = (url: any) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  const buttonClicked = (data: any) => {
    localStorage.setItem('CompanyData', JSON.stringify(data))
    localStorage.setItem('TimesheetSettings', JSON.stringify(data))
    openInNewTab(`${window.location.origin}/timesheetsettings`)
  }


  const viewDetails = (props: GridCellProps) => {


    return (
      <td>
        <div onClick={() => buttonClicked(props.dataItem)} style={{ 'color': '#14A800', 'fontWeight': 400 }} >View Details</div>
      </td>
    )
  }

  const approvalNeededCell = (props: GridCellProps) => {
    return (
      <td>
        {props.dataItem.approvalNeeded && props.dataItem.approvalNeeded === 'true' ? 'Yes' : 'No'}
      </td>
    )
  }

  const leavesAllowedCell = (props: GridCellProps) => {
    return (
      <td>
        {props.dataItem.paidLeaveAllowed && props.dataItem.paidLeaveAllowed === 'true' ? 'Allowed' : 'Not Allowed'}
      </td>
    )
  }

  const carryForwardCell = (props: GridCellProps) => {
    return (
      <td>
        {props.dataItem.carryForwardAllowed && props.dataItem.carryForwardAllowed === 'true' ? 'Allowed' : 'Not Allowed'}
      </td>
    )
  }

  return (
    <>
      <Grid
        data={Props.state.items}
        onPageChange={Props.pageChange}
        total={Props.state.total}
        skip={Props.state.skip}
        pageable={Props.state.pageable}
        pageSize={Props.state.pageSize}
        onItemChange={Props.itemChange}
        sortable={true}
        sort={sort}
        onSortChange={(e) => {
          setSort(e.sort);
          Props.setSort(e.sort);
          Props.applySort(e.sort);
        }}
      >
        <GridNoRecords>
                    <div className="noData">
                        <Icon icon="mdi:smiley-neutral-outline" />
                        No data to display
                    </div>
                </GridNoRecords>
        <Column field="companyName" title="Company Name" width='200px' />
        <Column field="activeContractsCount" title="Active Contracts" width='200px' />
        <Column field="approvalNeeded" title="Timesheet Approval" width='200px' cell={approvalNeededCell} />
        <Column field="leaves" title="Leaves" width='200px' cell={leavesAllowedCell} />
        <Column field="carryForwardAllowed" title="Leaves Carry Forward" width='200px' cell={carryForwardCell} />
        <Column cell={viewDetails} />
      </Grid>
    </>
  )
}

export default CompanyTimesheet